module.exports = __webpack_public_path__ + "static/media/coin-icon.23eb56f4.png";